<template>
  <div class="weixin" id="weixin-cc" @change="XYchange">
    <div class="weixin_img pointer" @click.stop="showWeixin" @mousedown.stop>
      <transition
        :enter-class="xy_class + '-enter'"
        enter-active-class="enter-active"
        enter-to-class="enter-to"
        leave-class="leave"
        leave-active-class="leave-active"
        :leave-to-class="xy_class + '-leave-to'"
      >
        <div v-show="show" class="weixin-code" :class="xy_class" @click.stop @mousedown.stop>
          <div @click.stop @mousedown.stop>
            <img @click.stop @mousedown.stop :src="baseApi + chatServicePic" alt="">
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script type="es6">
import {baseApis} from "../../utils/mixins/baseApiMixin"
export default {
  name: 'pp',
  mixins: [baseApis],
  data() {
    return {
      show: false,
      debounceFun: null,
      width: Math.max(document.body.offsetWidth, window.innerWidth),
      height: Math.max(document.body.offsetHeight, window.innerHeight),
      xy_class: 'left-Ycenter'
    }
  },
  props: {
    chatServicePic: {
      tpye: String,
      default: ''
    }
  },
  mounted() {
    this.debounceFun = this.commonJs.debounce(this.VV, 300, true)
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const target = event.target
      const isInside = this.$el.contains(target)
      if (!isInside && this.show) {
        this.show = false
      }
    },
    VV () {
      let xx, yy
      if (this.X < this.width / 3) {
        xx = 'right'
      } else if (this.X >= (this.width / 3) && this.X <= (this.width / 3 * 2)) {
        xx = 'Xcenter'
      } else {
        xx = 'left'
      }
      if (this.Y < 200) {
        yy = 'bottom'
      } else if (this.Y >= 200 && this.Y <= (this.height - 200)) {
        yy = 'Ycenter'
      } else {
        yy = 'top'
      }
      let xy_class = `${xx}-${yy}`
      this.xy_class = xy_class === 'Xcenter-Ycenter' ? 'Xcenter-top' : xy_class
    },
    XYchange(v) {
      if (this.show) this.show = false
      this.X = v.x + 34
      this.Y = v.y + 34
      this.debounceFun()
    },
    showWeixin(el) {
      let isClick = el.target.parentNode.getAttribute('flag')
      if(isClick ==='false') return false
      let drag = el.target.parentNode.getAttribute('drag')
      if (drag === 'no') {
        el.target.parentNode.setAttribute('drag', null)
        el.target.parentNode.classList.add('acc')
        return false
      }
      this.show = this.show ? false : true
    },
  },
}
</script>

<style lang='scss' scoped>
.weixin {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 3px solid #fff;
  background: #52C41A;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: all 1s;
  box-sizing: border-box;
  .weixin_img{
    width: 100%;
    height: 100%;
    background: url('../../../static/images/weixin.svg') no-repeat;
    background-size: 80%;
    background-position: center;
    position: relative;
    .weixin-code{
      position: absolute;
      & > div {
        width:150px;
        height:150px;
        border: 1px dashed #ccc;
        border-radius: 4px;
        position: relative;
        img{
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
          display: block;
          max-width: 100%;
          max-height: 100%;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          outline: none;
        }
      }
    }
    .weixin-code.right-bottom {
      top: 60px;
      left: 60px;
    }
    .weixin-code.right-Ycenter{
      top: -44px;
      left: 100px;
    }
    .weixin-code.right-top{
      top: -148px;
      left: 62px;
    }
    .weixin-code.left-bottom {
      top: 61px;
      left: -152px;
    }
    .weixin-code.left-Ycenter{
      top: -44px;
      left: -195px;
    }
    .weixin-code.left-top{
      top: -150px;
      left: -150px;
    }
    .weixin-code.Xcenter-top{
      top: -196px;
      left: -44px;
    }
    .weixin-code.Xcenter-bottom{
      top: 108px;
      left: -44px;
    }
  }
}
.enter-active, .leave-active { transition: all 0.3s ease; }
.enter-to, .leave { transform: translate(0, 0) scale(1); opacity: 1; }

.right-bottom-enter, .right-bottom-leave-to{ opacity: 0; transform: translate(-60%, -60%) scale(0); }
.right-Ycenter-enter, .right-Ycenter-leave-to{ opacity: 0; transform: translate(-100%, 0) scale(0); }
.right-top-enter, .right-top-leave-to{ opacity: 0; transform: translate(-60%, 60%) scale(0); }
.left-bottom-enter, .left-bottom-leave-to{ opacity: 0; transform: translate(60%, -60%) scale(0); }
.Xcenter-top-enter, .Xcenter-top-leave-to { opacity: 0; transform: translate(0, 100%) scale(0); }
.left-Ycenter-enter,
.left-Ycenter-leave-to { opacity: 0; transform: translate(100%, 0) scale(0); }
.left-top-enter, .left-top-leave-to { opacity: 0; transform: translate(60%, 60%) scale(0); }
.Xcenter-bottom-enter, .Xcenter-bottom-leave-to { opacity: 0; transform: translate(0, -100%) scale(0); }

</style>



// WEBPACK FOOTER //
// src/components/base/pp.vue